import * as React from 'react';
import { PageBack, PageTitle } from '@uifabric/portal-ux/lib/Page';
import { useTheme } from '@fluentui/react';
import { QosProvider } from '@iamexperiences/ecos-telemetry';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';

import { AcceptanceList } from './AcceptanceList';
import { useGetTenantDisplayNameAuthenticated } from '../hooks/useGetTenantDisplayName';
import { usePageTitle } from '../../shared/usePageTitle';
import { NAVIGATION_LINKS } from '../../shared/constants';
import { Page } from '../../Application/Page';

export const MyAcceptances: React.FC = () => {
  const theme = useTheme();
  const [t] = useLocalization('TermsOfUse');
  usePageTitle(t('termsOfUse'));

  const getTenantDisplayNameQuery = useGetTenantDisplayNameAuthenticated();
  const pageBackPath = NAVIGATION_LINKS.settingsAndPrivacy.subRoutePaths!.privacy.link;

  return (
    <QosProvider name="TermsOfUseMyAcceptances">
      <Page
        automationId="TermsOfUse"
        styles={{
          root: { fontSize: theme.fonts.medium.fontSize },
        }}
      >
        <PageBack path={pageBackPath}>{t('goBack')}</PageBack>
        {getTenantDisplayNameQuery.isSuccess && (
          <>
            <PageTitle
              styles={() => ({
                root: {
                  fontSize: theme.fonts.xxLarge.fontSize,
                },
              })}
            >
              {getTenantDisplayNameQuery.data
                ? t('orgTermsOfUse', { orgName: getTenantDisplayNameQuery.data })
                : t('termsOfUse')}
            </PageTitle>
            <AcceptanceList orgName={getTenantDisplayNameQuery.data} />
          </>
        )}
      </Page>
    </QosProvider>
  );
};
